"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamWidgetContainer = void 0;
var _react = _interopRequireDefault(require("react"));
var _ToggleSwitch = require("../../ToggleSwitch");
var _StreamWidgetContainer = require("./StreamWidgetContainer.styled");
var StreamWidgetContainer = exports.StreamWidgetContainer = function StreamWidgetContainer(_ref) {
  var title = _ref.title,
    subHeader = _ref.subHeader,
    onToggleClick = _ref.onToggleClick,
    isEnabled = _ref.isEnabled,
    children = _ref.children,
    disabledText = _ref.disabledText,
    disabledIcon = _ref.disabledIcon,
    toggleSwitchId = _ref.toggleSwitchId;
  return _react["default"].createElement(_StreamWidgetContainer.Wrapper, null, _react["default"].createElement(_StreamWidgetContainer.TitleWrapper, null, _react["default"].createElement(_StreamWidgetContainer.Title, null, title), _react["default"].createElement(_StreamWidgetContainer.ToggleSwitchWrapper, {
    htmlFor: toggleSwitchId
  }, _react["default"].createElement(_ToggleSwitch.ToggleSwitch, {
    on: isEnabled,
    onClick: onToggleClick,
    id: toggleSwitchId,
    "data-testid": toggleSwitchId
  }))), isEnabled ? _react["default"].createElement("p", null, subHeader) : _react["default"].createElement(_StreamWidgetContainer.DisabledText, null, disabledText), isEnabled ? _react["default"].createElement(_react["default"].Fragment, null, children) : _react["default"].createElement(_StreamWidgetContainer.EmptyWrapper, null, _react["default"].createElement(_StreamWidgetContainer.QAIconsWrapper, null, _react["default"].createElement(_StreamWidgetContainer.QuestionIcon, {
    icon: disabledIcon
  }))));
};